



































import { computed, defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";
import useDarkModeController from "@/hooks/useDarkModeController";
import { darkModeReplacePostfix } from "@/lib/darkModeReplacePostfix";
import { getQuestionaryInfoFields } from "@/lib/questionaryFieldsHelper";
import config from "@/config";
import BaseIcon from "@/components/BaseIcon";

interface Social {
  id: string;
  href: string;
  iconName: string;
}
interface Info {
  id: string;
  text: string;
  class: string;
  tag: string;
  icon?: string;
  attrs: Record<string, string>;
}

export default defineComponent({
  name: "QuestionaryInfoPrinter",
  components: { BaseIcon },
  props: {
    questionaryInfo: {
      type: Object as () => Record<string, string>,
      required: true,
    },
    user: {
      type: Object as () => UserPublicData,
      required: true,
    },
  },
  setup(props) {
    const { isDarkMode } = useDarkModeController();
    const restrictedMember = computed(() => {
      return config.featureRestrictMember && checkRole(props.user.role, "member");
    });
    const availableInfos = computed((): Info[] => {
      return getQuestionaryInfoFields()
        .filter(
          i =>
            !i.fieldMeta?.social &&
            !i.fieldMeta?.amazon &&
            !i.fieldMeta?.calendar &&
            (restrictedMember.value ? i.fieldMeta?.allowedForMember : true) &&
            props.questionaryInfo[i.name]
        )
        .map(infoField => {
          const classes = [
            ...(infoField.fieldMeta?.description ? ["caption"] : []),
            ...(infoField.fieldMeta?.url ? ["questionary-info__link link mt-2"] : []),
          ];
          let text = props.questionaryInfo[infoField.name];
          if (infoField.fieldMeta?.url) {
            text = text.replace(/(^\w+:|^)\/\//, "");
          }
          return {
            id: infoField.name,
            text,
            class: classes.join(" "),
            tag: infoField.fieldMeta?.url ? "a" : "div",
            attrs: {
              ...(infoField.fieldMeta?.url ? { href: props.questionaryInfo[infoField.name], target: "_blank" } : {}),
            },
            ...(infoField.fieldMeta?.icon ? { icon: infoField.fieldMeta?.icon } : {}),
          };
        });
    });
    const availableSocials = computed(() => {
      if (restrictedMember.value) return [];
      return getQuestionaryInfoFields()
        .filter(i => i.fieldMeta?.social || i.fieldMeta?.calendar)
        .reduce((out, socialField) => {
          if (props.questionaryInfo[socialField.name])
            out.push({
              id: socialField.name,
              href: `${socialField.fieldMeta?.site ?? ""}${props.questionaryInfo[socialField.name]}`,
              iconName: darkModeReplacePostfix(socialField.appendIcon ?? "", isDarkMode.value),
            });
          return out;
        }, [] as Social[]);
    });
    const availableAmazonLinks = computed(() => {
      return getQuestionaryInfoFields()
        .filter(i => i.fieldMeta?.amazon)
        .reduce((out, amazonField) => {
          if (props.questionaryInfo[amazonField.name])
            out.push({
              id: amazonField.name,
              href: props.questionaryInfo[amazonField.name],
              iconName: darkModeReplacePostfix(amazonField.fieldMeta?.logo ?? "", isDarkMode.value),
            });
          return out;
        }, [] as Social[]);
    });
    return { isDarkMode, availableInfos, availableSocials, availableAmazonLinks };
  },
});
